import React from 'react'
import { Link } from 'react-router-dom'

const BadgeAchievement = (props) => {
  return (
    <div className='m-1 mb-2'>
        <Link to={props.active ? ("https://twitter.com/intent/tweet?text=【実績解除】" + props.name + "%0A" + props.description + "%0A%0A大規模鬼ごっこ運営Webアプリ 電鬼２%0Ahttps://traffic-tag-game.web.app") : null} className={'p-2 m-1 rounded-full inline-block w-14 h-14 text-3xl ' + (props.active ? 'border-2 border-yellow-500 shadow text-yellow-500 bg-yellow-50 hover:bg-yellow-50/60 hover:border-yellow-400 hover:text-yellow-400 animate-bounce' : 'border border-gray-200 shadow-sm text-gray-300 bg-white')}>
            <i className={'bi bi-' + props.icon}></i>
        </Link>
        <p className='text-sm text-gray-800'>{props.name}</p>
        <p className='text-sm text-gray-600'>{props.description}</p>
    </div>
  )
}

export default BadgeAchievement